import { useCallback, useEffect, useState } from "react";
import ApiDatabase from "server";

const EMPTY_STATE = { documents: [], unopenedCount: 0 };

// Loads the temp worker's end-of-mission documents once. A loading error is
// treated as an empty list: the section simply stays hidden.
const useEndOfMissionDocuments = () => {
    const [state, setState] = useState(EMPTY_STATE);

    useEffect(() => {
        let isActive = true;
        ApiDatabase.getEndOfMissionDocuments(
            {},
            (data) => {
                if (!isActive) return;
                setState({
                    documents: Array.isArray(data?.documents) ? data.documents : [],
                    unopenedCount: Number(data?.unopenedCount) || 0,
                });
            },
            (err) => {
                if (!isActive) return;
                console.error(err);
                setState(EMPTY_STATE);
            }
        );
        return () => {
            isActive = false;
        };
    }, []);

    // The api sets first_opened_at when /pdfView calls /open; this only mirrors it
    // locally so the dot and the badge update without reloading the list.
    const markDocumentOpened = useCallback((documentId) => {
        setState((previous) => {
            const target = previous.documents.find((document) => document._id === documentId);
            if (!target || target.status !== "available" || target.openedAt) return previous;
            return {
                documents: previous.documents.map((document) =>
                    document._id === documentId
                        ? { ...document, openedAt: new Date().toISOString() }
                        : document
                ),
                unopenedCount: Math.max(0, previous.unopenedCount - 1),
            };
        });
    }, []);

    return {
        documents: state.documents,
        unopenedCount: state.unopenedCount,
        markDocumentOpened,
    };
};

export default useEndOfMissionDocuments;
